export const expander = {
	init: ({ target, button, id }) => {
		target.setAttribute('tabindex', '-1');
		target.setAttribute('aria-hidden', 'true');
		target.setAttribute('role', 'dialog');
		// `aria-hidden` alone doesn't remove descendants from the tab order —
		// `inert` does, so a closed panel's links can't be aria-hidden AND
		// focusable at the same time (the axe/Lighthouse violation this fixes).
		target.inert = true;
		button.setAttribute('aria-controls', id);
		button.setAttribute('aria-expanded', 'false');
	},

	open: ({ button, target }) => {
		button.setAttribute('aria-expanded', 'true');
		target.setAttribute('aria-hidden', 'false');
		target.inert = false;
	},

	close: ({ button, target }) => {
		button.setAttribute('aria-expanded', 'false');
		target.setAttribute('aria-hidden', 'true');
		target.inert = true;
	},

	reset: ({ button, target }) => {
		target.removeAttribute('tabindex');
		target.removeAttribute('aria-hidden');
		target.removeAttribute('role');
		target.removeAttribute('style');
		target.inert = false;

		button.removeAttribute('aria-controls');
		button.removeAttribute('aria-expanded');
	},
};
